import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import configData from "../../temp/config";
import { isMobile } from "react-device-detect";
import "./pollen-tracker.css";

const PollenTracker = (props) => {
  const [componentData, setComponentData] = useState(props.fields);
  const { t } = props;

  // Calling Layout Service and Caching the response
  useEffect(() => {
    let componentData = props.fields;
    setComponentData(componentData);
  }, []);

  return (
    <>
      {componentData && (
        <section className="diaper-size-calc-wrap">
          {!isMobile && (
            <>
              <div className="container">
                <p className="description">{componentData.description.value}</p>
                <div className="text-center">
                  <img
                    src={`${configData.sitecoreApiHost}${componentData.image.value.src}`}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </>
          )}
          {isMobile && (
            <div className="text-center">
              <img
                src={`${configData.sitecoreApiHost}${componentData.MobileImage.value.src}`}
                alt=""
                className="img-fluid"
              />
            </div>
          )}
          <div className="btn-container my-4">
            <a
              href={t("PollenTracker_KleenexUKLink")}
              target="_blank"
              className={isMobile ? 'btn-navigate': 'btn-navigate mr-3'}
            >
              {t("PollenTracker_KleenexUKText")}
            </a>
            <a
              href={t("PollenTracker_KleenexFRLink")}
              target="_blank"
              className="btn-navigate"
            >
              {t("PollenTracker_KleenexFRText")}
            </a>
          </div>
        </section>
      )}
    </>
  );
};

export default withTranslation()(PollenTracker);
